<template lang="html">
  <div class="animated fadeIn">
    <b-card>
      <b-button-toolbar class="pull-right">
        <b-btn variant="primary" @click="showAddCharge">Add Bhaint Type</b-btn>
      </b-button-toolbar>
    </b-card>

    <b-card>
      <v-client-table :columns="columns" :data="chargeTypes" :options="options" :theme="theme" id="dataTable" ref="dataTable">
        <template slot="fixedcharges" slot-scope="data">
          {{getFixedChargeLable(data.row)}}
        </template>
        <template slot="active" slot-scope="data">
          {{getActiveLable(data.row)}}
        </template>
        <template slot="actions" slot-scope="data">
          <b-btn size="sm" variant="outline-primary" @click="showEditChargeType(data.row)" class="mr-1">Edit</b-btn>
        </template>

      </v-client-table>
    </b-card>
    <div>
      <b-modal ref="modalEditChargeType" title="Edit Bhaint Type" hide-footer @hide="hideEditChargeType">
        <charge-type-edit v-if="selectedChargeType" :chargeType="selectedChargeType" @success="editChargeTypeSuccess" @cancel="cancelEditChargeType" />
      </b-modal>
    </div>
    <div>
      <b-modal ref="modalAddChargeType" title="Add Bhaint Type" hide-footer >
        <charge-type-add  @success="addChargeTypeSuccess" @cancel="cancelAddChargeType" />
      </b-modal>
    </div>
  </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import Vue from 'vue'
  import ChargeTypeEdit from './ChargeTypeEdit'
  import ChargeTypeAdd from './ChargeTypeAdd'


  export default {
    name: 'ChargeTypeList',
    components: {
      ChargeTypeEdit,
      ChargeTypeAdd
    },

    data: function() {
      return {
        selectedChargeType: null,
        columns: ['name', 'amount', 'fixedcharges', 'active','actions'],
        options: {
          headings: {
            name: 'Name',
            amount: 'Per Unit Cost',
            fixedcharges: 'Fixed?',
            active: 'Enabled?'
          },
          sortable: ['name', 'amount', 'fixedcharges', 'active'],
          filterable: ['name', 'amount'],
          sortIcon: {
            base: 'fa',
            up: 'fa-sort-asc',
            down: 'fa-sort-desc',
            is: 'fa-sort'
          },
          pagination: {
            chunk: 5,
            edge: true,
            nav: 'scroll'
          },
          perPage: 25,
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
      }
    },
    computed: {
      chargeTypes(){
        return this.$store.state.electrical.chargeTypes;
      }
    },
    methods: {
      showAddCharge(){
        this.$refs.modalAddChargeType.show();
      },
      cancelAddChargeType() {
        this.$refs.modalAddChargeType.hide()
      },
      addChargeTypeSuccess() {
        this.$refs.modalAddChargeType.hide();
        this.$store.dispatch('electrical/getChargeTypes')
      },
      getActiveLable(chargeType){
        return chargeType.active == true ? 'Yes' : 'No';
      },
      getFixedChargeLable(chargeType){
         return chargeType.fixedcharges == true ? 'Yes' : 'No';
      },
      showEditChargeType(chargeType) {
        this.selectedChargeType = chargeType
        this.$refs.modalEditChargeType.show()
      },
      cancelEditChargeType() {
        this.$refs.modalEditChargeType.hide()
      },
      editChargeTypeSuccess() {
        this.$refs.modalEditChargeType.hide();
        this.$store.dispatch('electrical/getChargeTypes')
      },
      hideEditChargeType() {
        this.selectedChargeType = null
      },
    },
    created() {
      if (this.$store.state.electrical.chargeTypes.length == 0) {
        this.$store.dispatch('electrical/getChargeTypes');
      }
    }
  }
</script>

<style lang="css">
</style>
